export default __webpack_public_path__ + "static/media/iraq logo.4b7f231d.webp";